// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.98.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  height: 100vh;
  overflow-x: hidden;
}
#app-root {
  height: 100%;
}
.root-layout {
  height: 100%;
}
.section {
  background: #FFF !important;
}
.ant-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-table-wrapper {
  border-radius: 2px;
}
.ant-layout-content.page-content .ant-table-wrapper .ant-table {
  border: 1px solid #F0F0F0;
  border-radius: 2px;
  border-start-end-radius: 2px;
  border-start-start-radius: 2px;
}
.ant-layout-content.page-content .page-title {
  font-size: 24px;
  font-weight: 400;
  line-height: 28px;
  margin-top: 0.04rem;
  margin-bottom: 2.5rem;
}
.ant-table-pagination {
  border: none !important;
}
.ant-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.ant-layout-header.page-header > .ant-row {
  width: 100%;
}
.ant-layout-content.page-content {
  flex-shrink: 0;
}
.ant-layout-content.page-content .ant-card {
  margin: 0 24px 24px 24px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
}
.ant-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
.ant-layout-content.app-content {
  flex-shrink: 0;
  height: 100%;
  overflow-x: hidden;
  background-color: #ffffff;
}
.page-layout {
  position: relative;
}
body .ant-message {
  margin-top: 64px;
}
.ant-table-cell div .action-icon svg {
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}
.search-input {
  width: 545px;
  height: 32px;
  flex-shrink: 0;
}
.search-input .ant-input-wrapper .ant-input .ant-input-group-addon .ant-btn {
  border-start-start-radius: 0px !important;
  border-end-start-radius: 0px !important;
}
.trigger-deatil-row {
  display: flex;
  flex-flow: row;
  align-items: center;
  gap: 10px;
}
.applies-to-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  grid-template-rows: 1fr 1fr 1fr;
}
.ant-checkbox-wrapper {
  margin: 0px 0px 15px 0px;
}
.ant-checkbox-wrapper span:first-child {
  border-radius: 2px !important;
  width: 16px;
  height: 16px;
}
.ant-checkbox-wrapper .ant-checkbox-inner {
  border-radius: 2px !important;
  display: block !important;
  width: 16px !important;
}
.ant-checkbox-wrapper span:last-child {
  display: flex;
  width: max-content;
}
.prerequisites-container {
  gap: 18px;
  display: flex;
  flex-direction: column;
}
.actions-column {
  display: flex;
  flex-direction: row;
}
.button-container {
  gap: 11px;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}
.add-property-row {
  margin-left: 0px !important;
  margin-right: 0px !important;
  margin-bottom: 22px;
  display: flex;
  justify-content: flex-end;
  margin-left: auto;
}
body {
  font-size: 16px;
  line-height: 1.5;
  font-family: Inter-UI, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Fira Sans", "Droid Sans", "Helvetica Neue", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-weight: normal;
  margin: 0;
  background-color: #d1d1d1;
}
.app-container {
  min-height: calc(100vh - 140px);
  background-color: #F0F2F5;
}
.app-container > div > .container {
  background-color: #F0F2F5;
  border-radius: 4px;
}
.header-col {
  display: flex !important;
}
.help-icon {
  font-size: 27px;
}
.ant-tag {
  color: #595959;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
}
.search-form {
  margin-bottom: 24px;
}
.add-trigger-btn {
  width: fit-content !important;
  float: right;
}
.applies-to-list-tag {
  margin: 5px;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
